import React from 'react'
import { Redirect } from 'react-router'
import { IState } from '../models/state'
import { Field, reduxForm, } from 'redux-form'
import { renderField, isEmail, required, maxLength100, minLength6 } from './renderField'
import { ws } from '../functions/ws'
import { useSelector } from 'react-redux'
import { ILogin } from 'exchange-common'

let LoginForm = (props: any) => {
	const { handleSubmit, pristine, submitting } = props

	return (
		<div className='loginBox' >
			<form className='loginForm' onSubmit={handleSubmit}>
				<h2>Admin Dashboard</h2>
				<label htmlFor='email'>Email</label>
				<Field name='email' component={renderField} type='email' placeholder='your@email.com' validate={[isEmail, required, maxLength100]} />
				<label htmlFor='password'>Password</label>
				<Field name='password' component={renderField} type='password' validate={[required, minLength6]} />
				<label htmlFor='auth'>2FA token (if enabled)</label>
				<Field name='auth' component={renderField} type='text' />
				<button type='submit' disabled={submitting || pristine}>Login</button>
			</form>
		</div>
	)
}

LoginForm = reduxForm({
	form: 'login'
})(LoginForm) as any

export const Login = () => {
	const isLogged = useSelector<IState, boolean>((state) => state.user.isLogged)
	const onSubmit = (login: ILogin) => {
		const action = { type: 'User.LoginAdmin', login }
		ws.send(action as any)
	}

	if (isLogged) {
		return <Redirect to={`/dashboard/`} />
	}

	return (
		<div className='login'>
			<LoginForm onSubmit={(login: ILogin) => onSubmit(login)} />
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/login.tsx